<template>
	<div class="container-fluid">
		<h2 class="mb-3">Month View</h2>
		<label for="month">Select a month:</label>
		<input type="month" id="month" v-model="selectedMonth" class="mb-5" />
		<h3 v-if="loading">Loading...</h3>
		<glass-card
			v-for="(meals, date) in groupedResults"
			:key="date"
			class="mb-3 p-3">
			<h2>{{ date }}</h2>
			<div class="d-flex flex-row flex-wrap gap-5 cards">
				<food-card
					v-for="meal in meals"
					:key="meal.id"
					@click="selectMealCard(meal)"
					:meal="meal" />
			</div>
		</glass-card>
		<food-detail-modal
			:meal="selectedMeal"
			:show="showFDM"
			@close="closeModal" />
	</div>
</template>

<script setup>
	import { ref, onMounted, watch, onBeforeMount, onBeforeUnmount } from "vue"
	import FoodDetailModal from "@/components/FoodDetailModal.vue"
	import FoodCard from "@/components/FoodCard.vue"
	import moment from "moment-timezone"
	import { useTokenStore } from "@/stores/token"
	import { useUserStore } from "@/stores/user"
	// import { useRouter } from "vue-router"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	// import { lastMealUpdated, lastMealDeleted } from "@/utils/mealBus"
	import EventBus from "@/utils/eventBus"
	import GlassCard from "@/components/GlassCard.vue"

	const selectedMonth = ref(moment().format("YYYY-MM"))
	const groupedResults = ref({})
	const showFDM = ref(false)
	const selectedMeal = ref(null)
	const loading = ref(false)

	// const router = useRouter()
	const tokenStore = useTokenStore()
	const userStore = useUserStore()

	function closeModal() {
		selectedMeal.value = null
		showFDM.value = false
	}

	function selectMealCard(meal) {
		selectedMeal.value = meal
		showFDM.value = true
	}

	const fetchData = async () => {
		loading.value = true
		try {
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const response = await fetchWithAuth(
				`/api/monthly-view?date=${selectedMonth.value}`,
				{
					method: "GET",
					headers: {
						"User-Timezone": tz,
						// Authorization: `Bearer ${tokenStore.token}`,
					},
				}
			)
			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			if (response.ok) {
				const data = await response.json()
				// const groupedByDate = data.reduce((result, current) => {
				// 	const date = moment.unix(current.timestamp).format("MM-DD-YY")
				// 	result[date] = result[date] || []
				// 	result[date].push(current)
				// 	return result
				// }, {})
				// groupedResults.value = groupedByDate
				groupedResults.value = data
			} else {
				console.error("Failed to fetch data")
			}
			// }
		} catch (error) {
			console.error("Error fetching data:", error)
		}

		loading.value = false
	}

	onMounted(() => {
		// fetchData()
	})

	let timeout
	watch(selectedMonth, (v) => {
		// console.log("selectedMonth", v)
		clearTimeout(timeout)
		timeout = setTimeout(fetchData, 1000)
	})

	// watch(lastMealUpdated, (v) => {
	// 	if (v && selectedMeal.value && selectedMeal.value.id === v.id) {
	// 		selectedMeal.value = v
	// 	}
	// 	// console.log("lastMealUpdated", v)
	// 	fetchData()
	// })

	// watch(lastMealDeleted, (v) => {
	// 	// console.log("lastMealDeleted", v)
	// 	fetchData()
	// })

	let offMealUpdated = null
	let offMealDeleted = null

	onBeforeMount(() => {
		offMealUpdated = EventBus.on("meal-updated", (meal) => {
			if (selectedMeal.value && selectedMeal.value.id === meal.id) {
				selectedMeal.value = meal
			}
			fetchData()
		})

		offMealDeleted = EventBus.on("meal-deleted", (meal) => {
			if (!meal) return
			fetchData()
		})
	})

	onBeforeUnmount(() => {
		if (offMealUpdated) offMealUpdated()
		if (offMealDeleted) offMealDeleted()
	})

	watch(
		() => userStore.user,
		(v, ov) => {
			if (v) {
				fetchData()
			}
		},
		{ immediate: true }
	)
</script>

<style scoped>
	@media only screen and (max-width: 768px) {
		.cards {
			justify-content: center;
		}
	}
</style>
